module.exports = __webpack_public_path__ + "img/screenshot-profile-jobs.ef9c00cc.png";